import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const NAVY = '#1B2A6B';
const GOLD = '#C9A84C';

export default function ForgotPasswordPage() {
  const [email, setEmail]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
    } catch (_) {
      // Swallow error — always show generic success
    } finally {
      setLoading(false);
      setSubmitted(true);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${NAVY} 0%, #13204f 50%, #0d1534 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      {/* Decorative circles */}
      <div style={{ position: 'fixed', top: -80, right: -80, width: 320, height: 320, borderRadius: '50%', background: `rgba(201,168,76,0.08)`, pointerEvents: 'none' }} />
      <div style={{ position: 'fixed', bottom: -120, left: -60, width: 400, height: 400, borderRadius: '50%', background: `rgba(201,168,76,0.05)`, pointerEvents: 'none' }} />

      <div style={{ background: 'rgba(255,255,255,0.98)', borderRadius: 20, padding: '40px 36px', width: '100%', maxWidth: 400, boxShadow: '0 25px 80px rgba(0,0,0,0.3)' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 56, height: 56, background: `linear-gradient(135deg, ${NAVY}, #2d4299)`, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', boxShadow: `0 8px 24px rgba(27,42,107,0.3)` }}>
            <span style={{ fontSize: 24, fontWeight: 900, color: GOLD }}>N</span>
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 800, color: NAVY, marginBottom: 4 }}>Reset Your Password</h1>
          <p style={{ fontSize: 13, color: '#64748b' }}>We'll send a reset link to your email</p>
        </div>

        {submitted ? (
          <div>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}>📧</div>
              <p style={{ fontSize: 15, color: '#1e293b', fontWeight: 600, lineHeight: 1.6 }}>
                If an account exists with this email, a reset link has been sent.
              </p>
              <p style={{ fontSize: 13, color: '#64748b', marginTop: 8 }}>
                Check your inbox. The link expires in 15 minutes.
              </p>
            </div>
            <Link to="/login" style={{
              display: 'block', textAlign: 'center', padding: '11px', background: NAVY,
              color: '#fff', borderRadius: 10, fontSize: 14, fontWeight: 700, textDecoration: 'none',
            }}>← Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Email Address
              </label>
              <input
                type="email" required value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@novaera.in"
                style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: 10, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
                onFocus={e => e.target.style.borderColor = NAVY}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <button type="submit" disabled={loading}
              style={{
                width: '100%', padding: '12px', borderRadius: 10, border: 'none',
                background: loading ? '#94a3b8' : `linear-gradient(135deg, ${NAVY}, #2d4299)`,
                color: '#fff', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                boxShadow: loading ? 'none' : `0 4px 14px rgba(27,42,107,0.4)`,
              }}>
              {loading && <div style={{ width: 18, height: 18, border: '2.5px solid rgba(255,255,255,0.4)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />}
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <Link to="/login" style={{ fontSize: 13, color: '#64748b', textDecoration: 'none' }}>← Back to Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
